interface IndexByNumber {
  [key: number]: string,
};

export const AllTypes:IndexByNumber = {
    1: 'Sales/DS',
    2: 'Collect4Agent',
    3: 'Sales/IDS',
    4: 'Sales/IDS',
    5: 'Debit Memo',
    6: 'Our Sales (ORG)',
    7: 'PS Sales Only (ORG)',
    27: 'PS Sales Only (DEST)',
    11: 'Cost/DS',
    12: 'Loan2Agent',
    13: 'Cost/IDS',
    14: 'Cost/IDS',
    15: 'Credit Memo',
    16: 'Our Cost (ORG)',
    17: 'PS Cost Only (ORG)',
    37: 'PS Cost Only (DEST)',
    8: 'Duty Agent',
    10: 'Duty Customer',
    18: 'Duty Agent',
    20: 'Duty Customer',
    40: 'Duty Customer',
};

//<pt220824: For ChgTypeDesc>
export const AllTypesShort:IndexByNumber = {
  1: 'Sales/DS',
  2: 'Collect4Agent',
  3: 'Sales/IDS',
  4: 'Sales/IDS',
  5: 'Debit Memo',
  6: 'Sales/DS',
  7: 'PS Sales Only',
  27: 'PS Sales Only',
  11: 'Cost/DS',
  12: 'Loan2Agent',
  13: 'Cost/IDS',
  14: 'Cost/IDS',
  15: 'Credit Memo',
  16: 'Cost/DS',
  17: 'PS Cost Only',
  37: 'PS Cost Only',
  8: 'Duty Agent',
  10: 'Duty Customer',
  18: 'Duty Agent',
  20: 'Duty Customer',
  40: 'Duty Customer',
};

//export default AllTypes;
  